// extracted by mini-css-extract-plugin
module.exports = {"Popular":"popularSearches_Popular__86rVa"};